"use client";

import type { AbstractIntlMessages } from "next-intl";
import { NextIntlClientProvider } from "next-intl";
import { type PropsWithChildren, useEffect, useRef, useState } from "react";

import { getRuntimeMessages } from "@/i18n/messages";
import { type Locale } from "@/i18n/locales";

const DEFAULT_TIME_ZONE = "Asia/Ho_Chi_Minh";

type RuntimeIntlProviderProps = PropsWithChildren<{
  initialMessages: AbstractIntlMessages;
  locale: Locale;
}>;

export default function RuntimeIntlProvider({
  children,
  initialMessages,
  locale,
}: RuntimeIntlProviderProps) {
  const [messages, setMessages] = useState(initialMessages);
  const requestId = useRef(0);

  useEffect(() => {
    const currentRequestId = requestId.current + 1;
    requestId.current = currentRequestId;

    getRuntimeMessages(locale)
      .then((nextMessages) => {
        if (requestId.current === currentRequestId) {
          setMessages(nextMessages);
        }
      })
      .catch((error) => console.error("Failed to load runtime messages:", error));
  }, [locale]);

  return (
    <NextIntlClientProvider locale={locale} messages={messages} timeZone={DEFAULT_TIME_ZONE}>
      {children}
    </NextIntlClientProvider>
  );
}
